export interface Highlight {
  substring: string;
  type: 'positive' | 'negative';
  explanation: string;
}

export interface ChecklistItem {
  label: string;
  met: boolean;
  explanation: string;
}

export interface AnalysisResult {
  score: number;
  checklist: ChecklistItem[];
  overallFeedback: string;
  highlights: Highlight[];
  rewrittenText: string;
}

export interface HistoryItem {
  id: string;
  timestamp: number;
  inputText: string;
  result: AnalysisResult;
}

export interface User {
  id: string;
  name: string;
  email: string;
  photoURL?: string;
}

export enum AppState {
  IDLE = 'IDLE',
  ANALYZING = 'ANALYZING',
  RESULTS = 'RESULTS',
  ERROR = 'ERROR'
}

// Admin emails for access control
export const ADMIN_EMAILS = [
  'mariela@masempatia.com',
  'david@inteligencialegal.com.ar'
];

export interface UserStats {
  userId: string;
  email: string;
  name: string;
  analysisCount: number;
  lastActive: number;
}

export interface DailyStats {
  date: string;
  analysisCount: number;
}

export interface AdminAnalytics {
  totalUsers: number;
  totalAnalyses: number;
  analysesToday: number;
  analysesThisWeek: number;
  analysesThisMonth: number;
  topUsers: UserStats[];
  dailyStats: DailyStats[];
}

// Modal Configuration Types
export interface AdvertisingModalConfig {
  enabled: boolean;
  title: string;
  message: string;
  linkText?: string;
  linkUrl?: string;
  frequency: 'always' | 'once_per_session' | 'once_per_day' | 'once_per_week' | 'every_2_analyses' | 'every_3_analyses' | 'every_5_analyses';
  buttonText: string;
  timeoutSeconds: number;
}